// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2-zd-","rootCenter":"LoadMoreObserver_rootCenter__1xhTq","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2EGYO"};